export class policyTypeMdl
{
   public PortalRegNo: string;
   public   isRenewal: string;
   public PrevPolicyNo: string;
   public PrevProposal: string;
   public  IsEditProposal: boolean;
   public  MedmalProposalEditMdlObj: MedmalProposalEditMdl=new MedmalProposalEditMdl();
   public IqamaNo: string;
   public RegNo: string;
   public DOBHijri:string
   public DOB:string
}

export class MedmalProposalEditMdl
{
    public ProposalNo: string;   
    public  JsonStr: string;    
    public ProposalId: string;  

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/policyTypeMdl.ts